import React from "react";
import SelectableTable from "../SelectableTable/Main.js";
import InputFormTable from "../InputFormTable/Main.js";
import update from "immutability-helper";
import { connect } from "react-redux";
import { openSwAction } from "../../redux/ui/actions";
import { changeSwModeAction } from "../../redux/app/actions";
import Sw from "../common/Sw";
import { hasEnvironment, getEnvironmentTypes, areEqual, getRegionEnvironment, getHyperParameter } from "./util.js";
import { getBoolListForSelectedEnv } from "../RegionEditor/util.js";

const mapStateToProps = (state) => {
    return {
        swMode: state.appReducer.swMode,
    };
};

/*★ここから公開版で削除*/
const initData = {
    environment: [
        {
            envType: "river",
            envID: 0,
            envName: "石狩川",
            envPath: "[W05-09_01-g_Stream.shp]",
            envRegion: "北海道",
        },
        {
            envType: "river",
            envID: 1,
            envName: "豊平川",
            envPath: "[W05-09_01-g_Stream.shp]",
            envRegion: "北海道",
        },
    ],

    regions: [
        {
            regionName: "札幌",
            regionID: 0,
            regionCoordSystem: "Exxx",
            regionRange: '{"x1":141.00,"x2":142.00,"y1":43.00,"y2":44.00}',
            env: [
                {
                    envType: "river",
                    envID: 0,
                    envName: "石狩川",
                    envPath: "[W05-09_01-g_Stream.shp]",
                    envRegion: "北海道",
                },
                {
                    envType: "river",
                    envID: 1,
                    envName: "豊平川",
                    envPath: "[W05-09_01-g_Stream.shp]",
                    envRegion: "北海道",
                },
            ],
        },
    ],

    hyperParam: {
        hyperParams: [
            {
                userID: 0,
                hyperParamID: 0,
                algorithmParam: '{"n_estimators":100,"max_depth":null," "n_jobs":null}',
                fs: "[0.1, 0.5, 0.9]",
                dz_nz: '{"dz":1.0,"nz":50.0}',
                range: '{"x1":140,"x2":141,"y1":39,"y2":40}',
                regionID: 0,
                modelPath: "XXX",
                algorithm: "randomforest",
                name: "札幌",
                env: [
                    {
                        envType: "river",
                        envID: 0,
                        envName: "石狩川",
                        envPath: "[W05-09_01-g_Stream.shp]",
                        envRegion: "北海道",
                    },
                    {
                        envType: "river",
                        envID: 1,
                        envName: "豊平川",
                        envPath: "[W05-09_01-g_Stream.shp]",
                        envRegion: "北海道",
                    },
                ],
            },
        ],

        selectedID: 0,
    },
};
/*★ここまで公開版で削除*/

class Main extends React.Component {
    /*★ここから公開版で削除*/
    constructor(props) {
        super(props);
        this.state = {
            environment: initData["environment"], //全環境情報
            hyperParams: initData["hyperParam"]["hyperParams"], //全ハイパーパラメータ
            regions: initData["regions"], //全地域情報
            selectedHyperParam: initData["hyperParam"]["hyperParams"][0], //選択中のハイパーパラメータ
            selectedEnvironments: [], //選択中のハイパーパラメータに選択された環境
            mode: "list",
            previousSelectedHyperParam: null, //前回選択されていたハイパーパラメータ
        };

        //TODO:ユーザIDに応じて動的にURLを作成できるようにすること
        //現時点ではユーザ0固定とする
        const origin = window.location.origin;
        const search = window.location.search;
        this.tmpURL = `${origin}/api/user/0/hyperparam/${search}`;
    }

    goBack = () => {
        this.props.dispatch(openSwAction(null));
        this.props.dispatch(changeSwModeAction(0));
    };

    /*
     * ハイパーパラメータリスト取得
     * フォーマットはinitData["hyperParam"]と同じ
     */
    loadHyperParam = async () => {
        const origin = window.location.origin;
        await fetch(`${this.tmpURL}`)
            .then((res) => res.json())
            .then((res) => {
                const selectedHyperParam = getHyperParameter(res.hyperParams, res.selectedID);
                this.setState({
                    hyperParams: res.hyperParams,
                    selectedHyperParam: selectedHyperParam,
                    selectedEnvironments: selectedHyperParam.env,
                });
                console.log("loadHyperParam:", res.hyperParams, res.selectedID);
            })
            .catch((err) => console.log(err));
    };

    /*
     * 環境情報取得
     * environmentフォーマットは
     * initData["environment"]と同じ
     */
    loadEnvironment = async () => {
        const origin = window.location.origin;
        const search = window.location.search;
        await fetch(`${origin}/api/environment/${search}`)
            .then((res) => res.json())
            .then((res) => {
                this.setState({ environment: res });
            })
            .catch((err) => console.log(err));
    };

    /*
     * 地域情報取得
     * regionフォーマットは
     * initData["region"]と同じ
     */
    loadRegion = async () => {
        const origin = window.location.origin;
        const search = window.location.search;
        await fetch(`${origin}/api/region/${search}`)
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    regions: res,
                });
            })
            .catch((err) => console.log(err));
    };

    async componentDidMount() {
        await this.loadEnvironment();
        await this.loadRegion();
        await this.loadHyperParam();
    }

    /* ハイパーパラメータリスト画面のイベントハンドラ */
    //ハイパーパラメータ新規作成画面へ遷移
    onAdd = (e) => {
        this.setState({
            mode: "add",
            previousSelectedHyperParam: this.state.selectedHyperParam,
            selectedHyperParam: this.createNewHyperParam(),
        });
    };

    //ハイパーパラメータ修正画面へ遷移
    onModify = (e) => {
        if (this.state.selectedHyperParam) {
            this.setState({ mode: "modify" });
        }
    };

    //ハイパーパラメータ削除画面へ遷移
    onDelete = async (e) => {
        if (!window.confirm("本当に削除しますか?")) {
            return;
        }
        if (!this.state.selectedHyperParam) {
            return;
        }
        const origin = window.location.origin;
        const search = window.location.search;

        console.log("onDelete selectedHyperParam:", this.state.selectedHyperParam.hyperParamID, this.state.selectedHyperParam);
        await fetch(`${origin}/${this.state.selectedHyperParam.hyperParamID}/${search}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    mode: "list",
                    hyperParams: res.hyperParams,
                    selectedHyperParam: getHyperParameter(res.hyperParams, res.selectedID),
                });
                console.log("onDelete:", res.hyperParams, res.selectedID);
            })
            .catch((err) => console.log(err));
    };

    //ハイパーパラメータの選択変更ハンドラ
    //ハイパーパラメータの選択変更をサーバに通知
    onHyperParamCheckedChange = async (checked, index) => {
        let selectedHyperParam = this.state.hyperParams[index];
        const origin = window.location.origin;
        const search = window.location.search;
        //選択したハイパーパラメータのIDをDBに登録
        await fetch(`${this.tmpURL}/${selectedHyperParam.hyperParamID}/${search}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                const selectedHyperParam = getHyperParameter(res.hyperParams, res.selectedID);
                this.setState({
                    mode: "list",
                    selectedHyperParam: selectedHyperParam,
                    selectedEnvironments: selectedHyperParam.env,
                });
            })
            .catch((err) => console.log(err));
    };

    //ハイパーパラメータ新規作成時のテンプレートを返す
    createNewHyperParam = () => {
        return {
            algorithmParam: '{"n_estimators":100,"max_depth":null," "n_jobs":null}',
            fs: "[0.1, 0.5, 0.9]",
            dz_nz: '{"dz":1.0,"nz":50.0}',
            range: '{"x1":140,"x2":141,"y1":39,"y2":40}',
            regionID: 0,
            algorithm: "randomforest",
            name: "",
            env: [],
        };
    };

    /* ハイパーパラメータ編集画面ハンドラ */
    //地域一覧作成
    createRegionList = () => {
        let arr = [];
        const hyperParam = this.state.selectedHyperParam;

        this.state.regions.forEach((e, index) => {
            arr.push(
                <option key={e.regionID} value={e.regionID} defaultSelected={e.regionID === hyperParam.regionID}>
                    {e.regionName}
                </option>,
            );
        });
        return (
            <div className="l-row l-mtS">
                <label>地域選択：</label>
                <select className="selectM" onChange={this.changeRegion}>
                    {arr}
                </select>
            </div>
        );
    };

    //地域選択
    changeRegion = (e) => {
        const regionID = parseInt(e.target.value);
        let region;
        for (let r of this.state.regions) {
            if (r.regionID === regionID) {
                region = r;
                break;
            }
        }

        //地域番号更新
        let hyperParam = update(this.state.selectedHyperParam, {
            regionID: { $set: regionID },
            env: { $set: [] }, //地域選択変更時は選択していた環境はクリアする
        });

        this.setState({
            selectedHyperParam: hyperParam,
            selectedEnvironments: [], //地域選択変更時は選択していた環境はクリアする
        });
    };

    //環境選択
    onEnvCheckedChange = (checked, index) => {
        let selectedEnvironments;

        //現在選択中のハイパーパラメータに指定されている地域IDに紐づく環境を取得
        const regionEnvironment = getRegionEnvironment(this.state.regions, this.state.selectedHyperParam.regionID);

        let selected = regionEnvironment[index];
        console.log("onEnvCheckedChange before:", JSON.stringify(selectedEnvironments));
        if (checked) {
            selectedEnvironments = update(this.state.selectedEnvironments, { $push: [selected] });
        } else {
            selectedEnvironments = [...this.state.selectedEnvironments.filter((e) => e.envID != selected.envID)];
        }

        console.log("onEnvCheckedChange :", JSON.stringify(selectedEnvironments));
        this.setState({ selectedEnvironments: selectedEnvironments });
    };

    /*
     * ハイパーパラメータの追加(POST)/更新(PUT)
     * POST/PUTのregionフォーマットは
     * initData["hyperParam"]と同じ
     * POST時はサーバ側で新規にhyperParamIDを生成するため、hyperParamIDは指定しない
     */
    onUpdateHyperParam = async () => {
        const selectedHyperParam = update(this.state.selectedHyperParam, { env: { $set: this.state.selectedEnvironments } });
        let url;
        let method;
        const origin = window.location.origin;
        const search = window.location.search;
        if (this.state.mode == "add") {
            url = `${this.tmpURL}`;
            method = "POST";
        } else if (this.state.mode == "modify") {
            const hyperParamID = selectedHyperParam.hyperParamID;
            url = `${origin}/api/user/0/hyperparam/${hyperParamID}/${search}`;
            method = "PUT";
        }

        await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                hyperParam: selectedHyperParam,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    mode: "list",
                    hyperParams: res.hyperParams,
                    selectedHyperParam: getHyperParameter(res.hyperParams, res.selectedID),
                });
            })
            .catch((err) => console.log(err));
    };

    //新規追加/修正のキャンセル
    onCancelHyperParamEdit = () => {
        if (this.state.mode == "add") {
            this.setState({
                mode: "list",
                previousSelectedHyperParam: null,
                selectedHyperParam: this.state.previousSelectedHyperParam,
            });
        } else {
            this.setState({
                mode: "list",
            });
        }
    };

    //ハイパーパラメータの各設定値の変更内容を保存
    onHyperParameterChange = (e) => {
        let selectedHyperParam = update(this.state.selectedHyperParam, { [e.target.name]: { $set: e.target.value } });
        this.setState({ selectedHyperParam: selectedHyperParam });
    };
    /*★ここまで公開版で削除*/

    render() {
        /*★ここから公開版で削除*/
        {
            if (this.state.mode === "list") {
                //ハイパーパラメータ一覧画面
                return (
                    <Sw title="パラメータ">
                        <div>
                            {this.state.hyperParams ? (
                                <SelectableTable
                                    key="1"
                                    inputType="radio"
                                    name="hyperParams"
                                    onCheckChange={this.onHyperParamCheckedChange}
                                    dataList={this.state.hyperParams}
                                    excludedNames={["env", "userID"]}
                                    defaultCheckedList={this.state.selectedHyperParam ? areEqual(this.state.hyperParams, "hyperParamID", this.state.selectedHyperParam.hyperParamID) : []}
                                />
                            ) : null}

                            <div className="l-row">
                                <button className="sBtn" key="hyperParam add" onClick={this.onAdd}>
                                    新規
                                </button>
                                <button className="sBtn l-mlS" key="hyperParam mod" onClick={this.onModify}>
                                    修正
                                </button>
                                <button className="sBtn l-mlS" key="hyperParam del" onClick={this.onDelete}>
                                    削除
                                </button>
                            </div>

                            <div className="l-right l-mtM">
                                <button className="cBtn l-mlS" onClick={this.goBack}>
                                    閉じる
                                </button>
                            </div>
                        </div>
                    </Sw>
                );
            } else {
                //ハイパーパラメータ新規追加/修正画面

                //選択した地域に設定されている環境をデフォルトでチェックするためのリスト
                let defaultCheckedList = [];
                if (this.state.selectedHyperParam) {
                    const regionEnvironment = getRegionEnvironment(this.state.regions, this.state.selectedHyperParam.regionID);
                    defaultCheckedList = getBoolListForSelectedEnv(this.state.selectedHyperParam.env, regionEnvironment);

                    const selectedEnvID = [];

                    for (let e of this.state.selectedHyperParam.env) {
                        selectedEnvID.push(e.envID);
                    }

                    if (regionEnvironment) {
                        regionEnvironment.forEach((e, index) => {
                            if (selectedEnvID.includes(e.envID)) {
                                defaultCheckedList.push(true);
                            } else {
                                defaultCheckedList.push(false);
                            }
                        });
                    }
                }
                console.log("render edit defaultCheckedList:", defaultCheckedList);

                return (
                    <Sw title="パラメータ編集">
                        <div>
                            <fieldset className="Unit">
                                <legend>パラメータ</legend>
                                <InputFormTable
                                    onClickOK={null}
                                    onClickCancel={null}
                                    data={this.state.selectedHyperParam}
                                    excludedNames={["env", "regionID", "algorithmParam", "userID", "hyperParamID", "modelPath", "range", "algorithm", "name"]}
                                    //公開版ではdz_nzのみ開放
                                    //excludedNames={["env", "regionID", "userID", "hyperParamID", "modelPath","algorithmParam","fs","range","algorithm","name"]}
                                    onChange={this.onHyperParameterChange}
                                />
                            </fieldset>
                        </div>

                        {this.createRegionList()}

                        <SelectableTable
                            key="1"
                            inputType="checkbox"
                            name="hyperParam env"
                            onCheckChange={this.onEnvCheckedChange}
                            dataList={getRegionEnvironment(this.state.regions, this.state.selectedHyperParam.regionID)}
                            defaultCheckedList={defaultCheckedList}
                        />

                        <div className="l-right l-mtM">
                            <button className="sBtn" onClick={this.onUpdateHyperParam}>
                                OK
                            </button>
                            <button className="sBtn l-mlS" onClick={this.onCancelHyperParamEdit}>
                                Cancel
                            </button>
                        </div>
                    </Sw>
                );
            }
        }
        /*★ここまで公開版で削除 下のコメント解除*/
        //return (<React.Fragment></React.Fragment>);
    }
}

export default connect(mapStateToProps)(Main);
